import { TableViewDialog, TableDialogBtn } from "../style";
import Select from "react-select";
import { OptionImage } from "../../product/style";

const ModuleExpoDialog = ({
  orderItem,
  tableManager,
  updateModuleProperties,
  mutateCurrentRoom,
  end,
}) => {
  return (
    <TableViewDialog end={end} padding="0" onClick={(e) => e.stopPropagation()}>
      <div
        className="d-flex justify-content-between"
        style={{ backgroundColor: "#DDDDDD" }}
      >
        <div className="p-2 border-bottom fw-bold fs-5">Expo</div>
        <div className="p-2 border-bottom fw-bold fs-5">
          <i
            className="fa-solid fa-xmark fs-4 pointer"
            onClick={(e) => {
              e.stopPropagation();
              tableManager.clear();
            }}
          />
        </div>
      </div>
      <div className="d-flex flex-column row-gap-2">
        {["left", "right", "top", "bottom", "back"].map((side, index) => {
          const property = orderItem.property_list.find(
            (e) => e.identifier === `exposed_side_${side}`
          );

          if (!property) return;

          const selected = property.options.find(
            (e) => e.identifier === `exposed_side_${side}_true`
          ).selected;

          const colorProperty = orderItem.property_list.find(
            (e) => e.identifier === `${side}_expo_color`
          );

          return (
            <div
              key={index}
              className="d-flex align-items-center column-gap-4 border-bottom p-2"
              style={{ minWidth: "360px" }}
            >
              <label className="expo-toggle-switch position-relative fs-6">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={side}
                  defaultChecked={selected}
                  style={{ opacity: 0, width: 0, height: 0 }}
                  onChange={(event) => {
                    updateModuleProperties({
                      id: orderItem.id,
                      propIdentifier: property.uniq_id,
                      optionIdentifier: event.target.checked
                        ? `exposed_side_${side}_true`
                        : `exposed_side_${side}_false`,
                    });
                  }}
                />
                <span className="slider position-absolute start-0 end-0 top-0 bottom-0 d-flex align-items-center justify-content-center text-white fw-semibold">
                  <span>{side.charAt(0).toUpperCase() + side.slice(1)}</span>
                </span>
              </label>

              {selected && (
                <Select
                  autoFocus={index === 0}
                  className="list-summary-select"
                  key={index}
                  isDisabled={!selected}
                  value={
                    selected &&
                    colorProperty &&
                    (colorProperty.options.find((option) => option.selected) ||
                      null)
                  }
                  onChange={(selectedOption) => {
                    colorProperty.is_overridden_v2 = true;
                    colorProperty.options.forEach((o) => {
                      o.selected = o.identifier === selectedOption.identifier;
                    });
                    mutateCurrentRoom();
                    updateModuleProperties({
                      id: orderItem.id,
                      propIdentifier: colorProperty.uniq_id,
                      optionIdentifier: selectedOption.identifier,
                    });
                  }}
                  options={
                    colorProperty &&
                    colorProperty.options.map((option, optionIndex) => {
                      option.value = option.name;
                      option.label = (
                        <div key={optionIndex}>
                          {option.image && (
                            <OptionImage
                              src={option.image}
                              alt={option.name}
                              className="border border-dark rounded-circle me-2"
                            />
                          )}
                          {option.name}
                        </div>
                      );
                      option.isDisabled =
                        option.settings_disabled === true ||
                        option.settings_disabled === "true";
                      option.key = index;
                      return {
                        value: option.name,
                        label: option.name,
                        ...option,
                      };
                    })
                  }
                />
              )}
            </div>
          );
        })}
      </div>

      <div className="py-3 px-3">
        <TableDialogBtn
          onClick={(e) => {
            e.stopPropagation();
            tableManager.clear();
          }}
        >
          Done
        </TableDialogBtn>
      </div>
    </TableViewDialog>
  );
};

export default ModuleExpoDialog;
